
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-linejoin":"round","stroke-width":"3","d":"M41.69 17.973C32.639 9.048 20.294 4.173 7.5 4.516h0v25.126c6.765-.427 14.07 2.036 19.167 7.746 4.245 4.755 6.931 11.743 6.61 21.112h23.208c.331-16.603-4.815-30.466-14.795-40.527z"}}),_c('path',{attrs:{"fill":"#F95959","d":"M51.247 56.948h3.461c0-15.481-4.907-28.45-14.224-37.932A44.69 44.69 0 009.189 6v3.461c20.223.19 42.058 15.15 42.058 47.487z"}}),_c('path',{attrs:{"fill":"#FF9C05","d":"M48.212 56.972h3.438c0-14.438-4.742-26.648-13.395-35.325A41.726 41.726 0 009 9.414v3.461c18.753.237 39.023 14.083 39.212 44.097z"}}),_c('path',{attrs:{"fill":"#FFD404","d":"M44.75 56.877h3.77c0-13.49-4.243-24.798-12.28-32.883A38.193 38.193 0 009.19 12.828v3.722c17.116.047 35.56 12.707 35.56 40.327z"}}),_c('path',{attrs:{"fill":"#74D31F","d":"M41.93 56.948h3.461c0-12.376-3.911-22.807-11.308-30.204A35.23 35.23 0 009.19 16.502v3.438c15.742.071 32.74 11.664 32.74 37.008z"}}),_c('path',{attrs:{"fill":"#0BAAF3","d":"M39.18 56.948h3.438c0-11.356-3.604-20.958-10.432-27.762a32.646 32.646 0 00-23.044-9.483v3.461c14.462.072 30.038 10.693 30.038 33.784z"}}),_c('path',{attrs:{"fill":"#426AE8","d":"M40.01 56.972a34.85 34.85 0 00-9.246-25.486 30.204 30.204 0 00-21.574-8.89v3.413a26.671 26.671 0 0118.966 7.895 31.626 31.626 0 018.345 23.02l3.51.048z"}}),_c('path',{attrs:{"fill":"#EB84CF","d":"M34.723 56.948h2.584c0-21.622-14.604-31.46-28.117-31.46v2.584c12.257 0 25.533 9.033 25.533 28.876z"}})])])
          )
        }
      }
    